import React, { Component } from 'react';
import isContractInitialized from '../../utils/ContractInitializationState';
import LoadingAnimation from '../Components/LoadingAnimation';
import {
  addTransactionInProgress,
  transactionErrorHandler,
  transactionReceiptHandler
} from '../../utils/TransactionStateHelper';
import { TX_ERROR_REDEEM_COUPON, TX_REEDEEM_COUPON } from '../../utils/TransactionTypes';

export default class RedeemCoupon extends Component {
  constructor (props) {
    super(props);

    this.state = {
      couponName: '',
      contractLoaded: false
    };

    this.storageUnsubscribe = null;
    this.handleCouponNameChange = this.handleCouponNameChange.bind(this);
    this.handleReedemingCoupon = this.handleReedemingCoupon.bind(this);
  }

  componentDidMount () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(() => this.isContractLoaded());
  }

  isContractLoaded () {
    isContractInitialized() && !this.state.contractLoaded && this.init();
  }

  componentWillUnmount () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  init () {
    this.storageUnsubscribe && this.storageUnsubscribe();
    this.setState({contractLoaded: true});
  }

  handleCouponNameChange (event) {
    this.setState({
      couponName: event.target.value
    });
  }

  handleReedemingCoupon (event) {
    // We don't want normal page submit
    event.preventDefault();

    if (this.state.couponName === '') {
      window.notifications.showError('Coupon name is empty.');

      return;
    }

    window.contract
      .methods
      .redeemCoupon(this.state.couponName)
      .send({from: Storage.getState().account.currentAccount, gasPrice: 0})
      .on('transactionHash', (hash) => addTransactionInProgress(hash, TX_REEDEEM_COUPON, TX_ERROR_REDEEM_COUPON))
      .on('receipt', (receipt) => transactionReceiptHandler(receipt, () => {
        this.setState({
          couponName: '',
        });

        window.notifications.showSuccess('Coupon was successfully redeemed.');
      }))
      .on('error', (err, receipt) => transactionErrorHandler(err, receipt));
  }

  renderIfContractIsLoaded () {
    if (!this.state.contractLoaded) {
      return (<LoadingAnimation/>);
    }

    return (
      <form onSubmit={this.handleReedemingCoupon}>
        <div className="c-form-row">
          <label>Coupon code</label>
          <input type="text" placeholder="Coupon code" name="couponName" value={this.state.couponName}
                 onChange={this.handleCouponNameChange}/>
        </div>
        <div className="c-form-row">
          <input type="submit" value="Redeem coupon"/>
        </div>
      </form>
    );
  }

  render () {
    return (<div className="c-component c-redeem-coupon">
      <h2>Redeem coupon</h2>
      {this.renderIfContractIsLoaded()}
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/CouponPage/RedeemCoupon.js